(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-filters"] && !Shopify.designMode) return;
  try {
    function ksFiltersInit() {
  document.querySelectorAll('.ks-filter-shell').forEach((shell) => {
    if (shell.dataset.ready) return;
    shell.dataset.ready = '1';
    const form = shell.querySelector('.ks-filters');
    const refine = shell.querySelector('.ks-refine');
    const stateKey = 'ks-filter-state:' + location.pathname;
    let priceTimer;
    let submitting = false;

    const rememberState = () => {
      const optionScroll = Array.from(shell.querySelectorAll('.ks-options'), (options) => options.scrollTop);
      sessionStorage.setItem(stateKey, JSON.stringify({
        windowY: window.scrollY,
        refineOpen: Boolean(refine && refine.open),
        optionScroll
      }));
    };

    const restoreState = () => {
      const stored = sessionStorage.getItem(stateKey);
      if (!stored) return;
      sessionStorage.removeItem(stateKey);
      try {
        const state = JSON.parse(stored);
        if (refine && typeof state.refineOpen === 'boolean') refine.open = state.refineOpen;
        requestAnimationFrame(() => {
          window.scrollTo({ top: Number(state.windowY) || 0, behavior: 'instant' });
          shell.querySelectorAll('.ks-options').forEach((options, index) => {
            options.scrollTop = Number(state.optionScroll?.[index]) || 0;
          });
        });
      } catch {
        sessionStorage.removeItem(stateKey);
      }
    };

    const preserveQueryParameters = () => {
      form.querySelectorAll('[data-ks-preserved]').forEach((input) => input.remove());
      const existingNames = new Set(Array.from(form.elements, (field) => field.name).filter(Boolean));
      for (const [name, value] of new URLSearchParams(location.search)) {
        if (name === 'page' || name.startsWith('filter.') || existingNames.has(name)) continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.dataset.ksPreserved = 'true';
        form.append(input);
      }
    };

    const submitFilters = () => {
      if (!form || submitting) return;
      form.requestSubmit();
    };

    shell.querySelectorAll('.ks-tag-option a').forEach((link) => {
      const url = new URL(link.href, location.href);
      const params = new URLSearchParams(location.search);
      params.delete('page');
      url.search = params.toString();
      link.href = url.href;
      link.addEventListener('click', () => {
        rememberState();
        const selected = new URLSearchParams(new FormData(form));
        for (const [key, value] of params) {
          if (!key.startsWith('filter.') && !selected.has(key)) selected.append(key, value);
        }
        selected.delete('page');
        url.search = selected.toString();
        link.href = url.href;
      });
    });

    if (window.matchMedia('(max-width:700px)').matches && refine) refine.open = false;

    shell.querySelectorAll('.ks-facet-search').forEach((input) => {
      input.addEventListener('input', () => {
        const term = input.value.toLowerCase().trim();
        input.closest('.ks-facet').querySelectorAll('.ks-option').forEach((option) => {
          option.hidden = !option.textContent.toLowerCase().includes(term);
        });
      });
    });

    if (form) {
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"],input[type="radio"],select')) submitFilters();
        if (event.target.matches('[data-price-min],[data-price-max]')) submitFilters();
      });

      form.addEventListener('input', (event) => {
        if (!event.target.matches('[data-price-min],[data-price-max]')) return;
        clearTimeout(priceTimer);
        priceTimer = setTimeout(submitFilters, 650);
      });

      form.addEventListener('submit', (event) => {
        const min = form.querySelector('[data-price-min]');
        const max = form.querySelector('[data-price-max]');
        const error = form.querySelector('[data-price-error]');
        if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) {
          event.preventDefault();
          error.hidden = false;
          max.focus();
          return;
        }
        if (error) error.hidden = true;
        preserveQueryParameters();
        rememberState();
        submitting = true;
        shell.setAttribute('aria-busy', 'true');
        form.querySelectorAll('button[type="submit"]').forEach((button) => {
          button.disabled = true;
        });
      });
    }

    restoreState();
  });
}

ksFiltersInit();
document.addEventListener('shopify:section:load', ksFiltersInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-live-search"] && !Shopify.designMode) return;
  try {
    (()=>{const box=document.querySelector('#ks-search-results');if(!box)return;const form=box.closest('form'),input=form.querySelector('[name="q"]');let timer,controller,revision=0;input.setAttribute('aria-controls',box.id);input.setAttribute('aria-expanded','false');input.autocomplete='off';const close=()=>{box.hidden=true;input.setAttribute('aria-expanded','false');};const safeURL=value=>{const u=new URL(value,location.origin);return ['http:','https:'].includes(u.protocol)?u.href:null;};input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();const ticket=++revision,q=input.value.trim();close();if(q.length<2)return;timer=setTimeout(async()=>{controller=new AbortController();try{const url=new URL(box.dataset.suggestUrl,location.origin);url.search=new URLSearchParams({q,'resources[type]':'product','resources[limit]':'6','resources[options][fields]':'title,variants.title,variants.sku'});const res=await fetch(url,{signal:controller.signal});if(!res.ok)throw Error();const data=await res.json();if(ticket!==revision)return;box.replaceChildren();for(const p of data.resources?.results?.products||[]){const href=safeURL(p.url);if(!href)continue;const a=document.createElement('a');a.href=href;if(p.image){const src=safeURL(typeof p.image==='string'?p.image:p.image.url);if(src){const image=document.createElement('img');image.src=src;image.alt='';image.width=48;image.height=48;a.append(image);}}const title=document.createElement('span');title.textContent=p.title;a.append(title);box.append(a);}if(!box.children.length){const p=document.createElement('p');p.textContent=box.dataset.empty;box.append(p);}const all=document.createElement('a'),target=new URL(form.action);target.search=new URLSearchParams({q,type:'product','options[prefix]':'last'});all.href=target.href;all.textContent=box.dataset.all;box.append(all);box.hidden=false;input.setAttribute('aria-expanded','true');}catch(e){if(e.name==='AbortError'||ticket!==revision)return;const p=document.createElement('p');p.textContent=box.dataset.failure;box.replaceChildren(p);box.hidden=false;input.setAttribute('aria-expanded','true');}},220);});form.addEventListener('keydown',e=>{if(e.key==='Escape'){revision++;controller?.abort();close();input.focus();}if(['ArrowDown','ArrowUp'].includes(e.key)&&!box.hidden){const links=[...box.querySelectorAll('a')];if(!links.length)return;e.preventDefault();const index=links.indexOf(document.activeElement);links[(index+(e.key==='ArrowDown'?1:-1)+links.length)%links.length].focus();}});document.addEventListener('click',e=>{if(!form.contains(e.target))close();});form.addEventListener('focusout',()=>setTimeout(()=>{if(!form.contains(document.activeElement))close();},0));})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-spec-tag-group"] && !Shopify.designMode) return;
  try {
    function ksTagFiltersInit(){document.querySelectorAll('.ks-tag-search').forEach(input=>{if(input.dataset.ready)return;input.dataset.ready='1';input.addEventListener('input',()=>{const term=input.value.toLowerCase().trim();input.closest('.ks-spec-facet').querySelectorAll('.ks-tag-option').forEach(option=>option.hidden=!option.dataset.filterValue.includes(term));});});}ksTagFiltersInit();document.addEventListener('shopify:section:load',ksTagFiltersInit);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-storefront-copy"] && !Shopify.designMode) return;
  try {
    (()=>{
 const clean=container=>{
  if(!(container instanceof Element))return;
  const walker=document.createTreeWalker(container,NodeFilter.SHOW_TEXT,{acceptNode:node=>node.parentElement.closest('script,style,textarea,input,code')?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT});
  let node;
  while((node=walker.nextNode())){
   const next=node.nodeValue.replace(/, including Shopify,/g,'').replace(/including Shopify/g,'including our online-store provider');
   if(next!==node.nodeValue)node.nodeValue=next;
  }
 };
 const refresh=()=>document.querySelectorAll('[id*="consent"],[id*="privacy"],[role="alertdialog"]').forEach(clean);
 let scheduled=false;
 new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh();});}).observe(document.body,{childList:true,subtree:true,characterData:true});
 refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-warranty-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ks-warranty'))customElements.define('ks-warranty',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.plans=JSON.parse(this.querySelector('[data-warranty-variants]').textContent).sort((a,b)=>a.cap-b.cap);
  this.labels=JSON.parse(this.querySelector('[data-warranty-labels]').textContent);
  this.select=this.querySelector('[data-cover]');this.message=this.querySelector('[data-warranty-message]');
  this.money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
  this.select.addEventListener('change',()=>this.dispatchEvent(new CustomEvent('warrantychange',{bubbles:true})));
  if(this.dataset.mode==='product'){
   this.form=this.closest('form');this.servers=JSON.parse(this.querySelector('[data-server-variants]').textContent);
   this.serverTitle=JSON.parse(this.querySelector('[data-server-title]').textContent);
   const update=()=>{this.server=this.servers.find(v=>String(v.id)===String(this.form.elements.id.value));this.setValue(this.server?.price,this.server?.available);};
   this.form.elements.id.addEventListener('change',update);update();
   this.form.addEventListener('submit',async e=>{
    const plan=this.selected();if(!plan)return;e.preventDefault();if(this.busy||!this.form.reportValidity())return;
    const quantity=Number(this.form.elements.quantity.value);if(!Number.isInteger(quantity)||quantity<1)return;
    this.busy=true;const button=this.form.querySelector('[data-add]');button.disabled=true;this.message.textContent='';
    const group=crypto.randomUUID();const properties=Object.fromEntries([...new FormData(this.form)].filter(([k])=>/^properties\[.+\]$/.test(k)).map(([k,v])=>[k.slice(11,-1),v]));
    try{
     const res=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:this.server.id,quantity,properties:{...properties,_ks_warranty_group:group}},{id:plan.id,quantity,properties:{_ks_warranty_group:group,Server:this.serverTitle,SKU:this.server.sku||String(this.server.id),'Hardware value':this.money.format(this.server.price/100),'Cover from delivery':plan.years+' year'+(plan.years===1?'':'s')}}]})});
     if(!res.ok)throw Error();location.assign(this.dataset.cart);
    }catch{this.message.textContent=this.labels.failure;button.disabled=!this.server.available;this.busy=false;}
   });
  }else this.setValue(null,false);
 }
 setValue(cents,known=true){
  this.value=cents;this.known=known&&Number.isFinite(cents)&&cents>0&&this.dataset.currency==='GBP';
  for(const option of [...this.select.options].slice(1)){
   const years=Number(option.value),plan=this.known?this.plans.find(p=>p.years===years&&p.cap>=cents&&p.available):null;
   option.disabled=!plan;option.textContent=years+' '+(years===1?'year':'years')+' '+this.labels.total+(plan?' — +'+this.money.format(plan.price/100)+' '+this.labels.each:'');
  }
  if(this.select.selectedOptions[0]?.disabled)this.select.value='0';
  this.message.textContent=!this.known?this.labels.pending:this.select.options[1].disabled?this.labels.unavailable:'';
 }
 selected(){const years=Number(this.select.value);return years&&this.known?this.plans.find(p=>p.years===years&&p.cap>=this.value&&p.available)||null:null;}
});
  } catch(e) { console.error(e); }
})();

})();
